import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getCCMVitalEntriesByPatientId (patientId) {
    const response = await _axios.get(
      `/vitalentry/getbypatientid/${patientId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM vital entries by patient ID');
  },
  async getCCMVitalEntriesByPatientIdByMonthByYear (patientId, month = new Date().getMonth() + 1, year = new Date().getFullYear()) {
    const response = await _axios.get(
      `/vitalentry/getbypatientidbymonth/${patientId}`,
    {
      headers: {
        byMonth: month,
        byYear: year,
      },
    },
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM vital entries by patient ID and by month and by year');
  },
  async getCCMVitalEntriesByCCMRecordId (ccmRecordId) {
    const response = await _axios.get(
      `/vitalentry/getbyccmrecordid/${ccmRecordId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM vital entries by CCM record ID');
  },
  async getCCMVitalEntryById (id) {
    const response = await _axios.get(`/vitalentry/getbyid/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM vital entry by ID');
  },
  async addCCMVitalEntry (body) {
    const response = await _axios.post('/vitalentry', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error adding CCM vital entry');
  },
  async updateCCMVitalEntry (id, body) {
    const response = await _axios.put(`/vitalentry/${id}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM vital entry');
  },
  async deleteCCMVitalEntry (id) {
    const response = await _axios.delete(`/vitalentry/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM vital entry');
  },
  async disableMedicalNoteForThisVitalEntry (id) {
    const response = await _axios.put(`/vitalentry/disablemedicalnoteforthisvitalentry/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM vital entry');
  },
};
